module.exports = __webpack_public_path__ + "static/davos-cf3568be3dd4335702d42822bde365b9.png";